package core.config

import com.essntl.config.EssntlConfig

enum class BuildFlavor {
    Local,
    Development,
    Staging,
    Demo,
    Release,
    ;

    val isLocal: Boolean
        get() = this == Local

    val isDev: Boolean
        get() = this == Development

    val isStaging: Boolean
        get() = this == Staging

    val isRelease: Boolean
        get() = this == Release

    val isDemo: Boolean
        get() = this == Demo
}

val buildFlavor: BuildFlavor by lazy {
    val flavor = EssntlConfig.buildFlavor
    when (flavor.lowercase()) {
        "local" ->
            BuildFlavor.Local

        "development" ->
            BuildFlavor.Development

        "staging" ->
            BuildFlavor.Staging

        "demo" ->
            BuildFlavor.Demo

        "release" ->
            BuildFlavor.Release

        else ->
            BuildFlavor.Local
    }
}
